import { render, staticRenderFns } from "./PeopleDetail.vue?vue&type=template&id=8be04f9e&"
import script from "./PeopleDetail.vue?vue&type=script&lang=js&"
export * from "./PeopleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports